import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { porCobrar } from '../utils/cobros';
import { mensajeDeAviso, enlaceDeWhatsApp } from '../utils/estadoDeCuenta';

const moneda = (n) => '$' + Math.round(n || 0).toLocaleString('es-CO');
const dia = (f) => f
  ? new Date(f).toLocaleDateString('es-CO', { day: 'numeric', month: 'short', timeZone: 'UTC' })
  : '—';

// A quién hay que cobrarle, hoy y mañana.
//
// Lo pidió el dueño del negocio con estas palabras: «el listado debe colocar a
// los clientes que vencen un día de anticipación del pago de interés». Es una
// pantalla distinta de Morosos: aquí no se mira quién falló sino a quién hay
// que llamar HOY para que no falle.
//
// Los días son de ATRASO, contados desde la fecha en que le venció. No desde el
// último abono, que es lo que se mostraba antes y hacía que un cliente puntual
// apareciera con 36 días cuando llevaba 5.

const CAJA = {
  background: 'white', borderRadius: '10px', padding: '16px',
  boxShadow: '0 1px 3px rgba(0,0,0,.08)', marginBottom: '18px',
};

function Fila({ f, tono, ajustes, verMensaje, alVer }) {
  const c = f.cobro;
  // El mismo camino del estado de cuenta: se abre WhatsApp con el texto
  // escrito y quien cobra le da a enviar. No sale solo, y eso es a propósito:
  // un aviso automático con una cifra torcida no se puede recoger.
  const texto = mensajeDeAviso({ name: f.name }, c, {
    saludo: (ajustes && ajustes.saludo) || 'Buenas',
    cierre: (ajustes && ajustes.cierre) || 'Cualquier duda me escribe.',
  });
  const url = enlaceDeWhatsApp(f.phone, texto);
  const etiqueta = c.situacion === 'atrasado'
    ? `${c.diasAtraso} ${c.diasAtraso === 1 ? 'día' : 'días'} de atraso`
    : c.situacion === 'vence_hoy' ? 'le vence hoy'
    : 'le vence mañana';

  return (
    <tr>
      <td style={{ padding: '10px 8px', fontWeight: 600 }}>
        {f.name}
        {f.phone && (
          <div style={{ fontSize: '12px', fontWeight: 400, color: '#6b7280' }}>
            📞 {f.phone}
          </div>
        )}
      </td>
      <td style={{ padding: '10px 8px', whiteSpace: 'nowrap' }}>
        <span style={{
          background: tono.piso, color: tono.tinta, borderRadius: '999px',
          padding: '3px 10px', fontSize: '12px', fontWeight: 700,
        }}>
          {etiqueta}
        </span>
        <div style={{ fontSize: '12px', color: '#6b7280', marginTop: '3px' }}>
          {c.situacion === 'atrasado' || c.situacion === 'vence_hoy'
            ? `desde el ${dia(c.desdeCuandoDebe)}`
            : `el ${dia(c.proximoCobro)}`}
        </div>
      </td>
      <td style={{ padding: '10px 8px', textAlign: 'right', fontWeight: 700,
                   fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap' }}>
        {moneda(c.aCobrar)}
        <div style={{ fontSize: '11px', fontWeight: 400, color: '#6b7280' }}>
          de interés
        </div>
      </td>
      <td style={{ padding: '10px 8px', textAlign: 'right', whiteSpace: 'nowrap' }}>
        {url ? (
          <a href={url} target="_blank" rel="noopener noreferrer"
             style={{ padding: '7px 12px', borderRadius: '6px', background: '#25D366',
                      color: 'white', fontWeight: 700, fontSize: '13px',
                      textDecoration: 'none', display: 'inline-block' }}>
            💬 Avisarle
          </a>
        ) : (
          <span style={{ fontSize: '12px', color: '#9ca3af' }}>sin teléfono</span>
        )}
        {url && (
          <button onClick={() => alVer(verMensaje === f.loan_id ? null : f.loan_id)}
                  style={{ background: 'none', border: 'none', cursor: 'pointer',
                           color: '#6b7280', fontSize: '12px', display: 'block',
                           marginLeft: 'auto', marginTop: '3px' }}>
            {verMensaje === f.loan_id ? 'ocultar' : 'ver el mensaje'}
          </button>
        )}
        {verMensaje === f.loan_id && (
          <pre style={{ marginTop: '8px', padding: '10px', background: '#f9fafb',
                        border: '1px solid #e5e7eb', borderRadius: '7px',
                        whiteSpace: 'pre-wrap', textAlign: 'left', fontSize: '13px',
                        fontFamily: 'inherit', fontWeight: 400, maxWidth: '20rem' }}>
            {texto}
          </pre>
        )}
      </td>
    </tr>
  );
}

function Bloque({ titulo, pie, filas, tono, monto, ajustes, verMensaje, alVer }) {
  if (filas.length === 0) return null;
  return (
    <div style={CAJA}>
      <div style={{ display: 'flex', justifyContent: 'space-between',
                    alignItems: 'baseline', flexWrap: 'wrap', gap: '8px',
                    marginBottom: '10px' }}>
        <h3 style={{ margin: 0, fontSize: '17px', color: tono.tinta }}>
          {titulo} <span style={{ color: '#9ca3af', fontWeight: 400 }}>({filas.length})</span>
        </h3>
        <div style={{ fontWeight: 700, color: tono.tinta,
                      fontVariantNumeric: 'tabular-nums' }}>
          {moneda(monto)}
        </div>
      </div>
      {pie && (
        <p style={{ margin: '0 0 10px', fontSize: '13px', color: '#6b7280' }}>{pie}</p>
      )}
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '14px' }}>
          <tbody>
            {filas.map(f => (
              <Fila key={f.loan_id} f={f} tono={tono} ajustes={ajustes}
                    verMensaje={verMensaje} alVer={alVer} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function PorCobrar({ ajustes }) {
  const [datos, setDatos] = useState(null);
  const [error, setError] = useState('');
  const [aviso, setAviso] = useState(1);
  const [verMensaje, setVerMensaje] = useState(null);

  useEffect(() => {
    let vivo = true;
    axios.get('/api/delinquents')
      .then(res => { if (vivo) setDatos(res.data?.prestamos || []); })
      .catch(() => { if (vivo) setError('No se pudo cargar la lista'); });
    return () => { vivo = false; };
  }, []);

  if (error) return <div style={{ color: '#b91c1c' }}>{error}</div>;
  if (!datos) return <p style={{ color: '#6b7280' }}>Cargando…</p>;

  const r = porCobrar(datos, aviso);
  const vencenHoy = r.atrasados.filter(f => f.cobro.situacion === 'vence_hoy');
  const atrasados = r.atrasados.filter(f => f.cobro.situacion === 'atrasado');

  return (
    <div>
      <h2 style={{ marginTop: 0 }}>📅 Por cobrar</h2>
      <p style={{ color: '#6b7280', marginTop: '-8px' }}>
        A quién hay que llamar hoy, y a quién le vence mañana
      </p>

      <div style={{ ...CAJA, display: 'flex', alignItems: 'center', gap: '10px',
                    flexWrap: 'wrap' }}>
        <span style={{ fontSize: '14px' }}>Avisarme con</span>
        <select
          value={aviso}
          onChange={e => setAviso(Number(e.target.value))}
          style={{ padding: '6px 10px', borderRadius: '6px', border: '1px solid #d1d5db',
                   fontSize: '14px' }}
        >
          <option value={1}>1 día de anticipación</option>
          <option value={3}>3 días</option>
          <option value={7}>una semana</option>
        </select>
      </div>

      {r.total === 0 && (
        <div style={{ ...CAJA, textAlign: 'center', color: '#6b7280' }}>
          Nadie por cobrar hoy ni mañana. Todos al día.
        </div>
      )}

      <Bloque
        ajustes={ajustes} verMensaje={verMensaje} alVer={setVerMensaje}
        titulo="🔴 Atrasados"
        pie="Ya se les pasó la fecha. Los de arriba llevan más tiempo debiendo."
        filas={atrasados}
        monto={atrasados.reduce((s, f) => s + f.cobro.aCobrar, 0)}
        tono={{ tinta: '#b91c1c', piso: '#fee2e2' }}
      />

      <Bloque
        ajustes={ajustes} verMensaje={verMensaje} alVer={setVerMensaje}
        titulo="🟠 Les vence hoy"
        pie="Todavía se pueden cobrar a tiempo."
        filas={vencenHoy}
        monto={vencenHoy.reduce((s, f) => s + f.cobro.aCobrar, 0)}
        tono={{ tinta: '#b45309', piso: '#fef3c7' }}
      />

      <Bloque
        ajustes={ajustes} verMensaje={verMensaje} alVer={setVerMensaje}
        titulo="🟢 Por vencer"
        pie="Avisarles antes de que se les pase."
        filas={r.proximos}
        monto={r.montoProximo}
        tono={{ tinta: '#15803d', piso: '#dcfce7' }}
      />

      {r.total > 0 && (
        <p style={{ fontSize: '13px', color: '#6b7280' }}>
          Los días son de <strong>atraso</strong>: se cuentan desde la fecha en que
          le venció el interés, no desde el último abono. El calendario va desde
          que empezó el préstamo, así que pagar tarde no corre la fecha del
          siguiente cobro.
        </p>
      )}
    </div>
  );
}

export default PorCobrar;
